import { ReactNode } from "react";
import { Avatar, Card, Col, Space } from "antd";
import { ComponentDeployment } from "../types";
import GitCommitLink from "./GitCommitLink";

export interface DeploymentCardProps {
    title?: ReactNode;
    extra?: ReactNode;
    value?: ComponentDeployment;
    span?: number;
    emptyText?: string;
    size?: 'default' | 'small';
}

const DeploymentCard = ({
    value,
    span,
    emptyText,
    title,
    extra,
    size
}: DeploymentCardProps) => {

    return (
        <>
            {
                value && value.initiator ?
                    <Col span={span}>
                        <Card type="inner" title={title} extra={extra} size={size}>
                            <Space direction="vertical">
                                <b>{value.commitMessage}</b>
                                <div>
                                    Commit by <Avatar src={value.initiator.avatar} size="small" /> {value.initiator.name}
                                </div>
                                <div>
                                    <GitCommitLink version={value.version} repoUrl={value.repositoryUrl} commitType={value.commitType} branch={value.branch} /> {value.createdAt}
                                </div>
                            </Space>
                        </Card>
                    </Col> :
                    value && !value.initiator ?
                        <Col span={span}>
                            <Card type="inner" title={title} size={size}>
                                <Space direction="vertical">
                                    <b>Manual deployment of {value?.repositoryUrl}</b>
                                    <div>
                                        Initiated by {value?.createdBy}
                                    </div>
                                    <div>
                                        {value?.createdAt}
                                    </div>
                                </Space>
                            </Card>
                        </Col> :
                        <Col span={span} style={{ display: "inline-flex", alignSelf: "stretch" }}>
                            <Card type='inner' size={size} title={title} className='flex-justify-center flex-align-center' style={{ width: "100%" }}>
                                <div>
                                    <i>{emptyText || "No deployment available"}</i>
                                </div>
                            </Card>
                        </Col>
            }
        </>
    )
}

export default DeploymentCard;